import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import MainNavigation from "./MainNavigation";
import Footer from "./Footer";
import "./Layout.css";

const Layout = (props) => {
    const bgColor = useSelector(state => state.theme.bgColor);
    return (
        <Fragment>
            <MainNavigation />
            <main className={bgColor === false ? "" : "layout"}>
                {props.children}
            </main>
            <Footer />
        </Fragment>);
}

export default Layout;